import { uuid } from './uuid';

const SplitTerm = '_particle-';

export namespace ParticleIdUtils {
  export function getParticleIdRoot(id: string) {
    return id.split(SplitTerm)[0];
  }

  export function generateParticleId(
    currentId: string,
    uuidFn: uuid.UuidFunc = uuid.getUuid
  ) {
    return `${getParticleIdRoot(currentId)}${SplitTerm}${uuidFn()}`;
  }
}
